import React from 'react';
import PropTypes from 'prop-types';
import { MoreNewsItem }
from '@fuww/library/src/Articles/Sections/MoreNews';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import CardWithLink from '../../../CardWithLink';
import getArticlesQuery from '../../../../lib/queries/news/getArticlesQuery';
import getArticlesField from '../../../../lib/queries/news/getArticlesField';
import { featuredCategoryIds } from '../../../../lib/mainCategoryIds';
import { useSiteContext } from '../../../SiteContext';
import withQuery from '../../../../lib/withQuery';
import useNoCacheOnServerFetchPolicy
from '../../../../lib/useNoCacheOnServerFetchPolicy';

const errorMessage = 'Error loading news articles...';

const imageConfigurations = [
  {
    width: 42,
    height: 28,
    quality: 10,
    resize: 'FILL_DOWN',
  },
  { width: 312, height: 208, resize: 'FILL_DOWN' },
  { width: 624, height: 416, resize: 'FILL_DOWN' },
  { width: 720, height: 480, resize: 'FILL_DOWN' },
];

const MoreNewsCards = ({
  data, variables, field, showCreatedAt,
}) => (
  data && data[field] && (
    <>
      {
        data[field].map((article, index) => (
          <MoreNewsItem
            key={article.title}
            className="fu-read-more"
            borderRight={
              data[field][index + 1] && '1px solid var(--grey-light)'
            }
            padding={
              data[field][index + 1] && '0 24px 0 0'
            }
          >
            <CardWithLink
              newsArticle={article}
              variables={variables}
              sizes={`
                (min-width: 1440px) 318px,
                (min-width: ${breakpoints.lg}px) 23vw,
                (min-width: ${breakpoints.sm}px) 47vw,
                100vw
              `}
              showCreatedAt={showCreatedAt}
              withPageMargins
            />
            <SpacingContainer />
          </MoreNewsItem>
        ))
      }
    </>
  )
);

MoreNewsCards.propTypes = {
  data: PropTypes.shape({}),
  variables: PropTypes.shape({}).isRequired,
  field: PropTypes.string.isRequired,
  showCreatedAt: PropTypes.bool,
};

MoreNewsCards.defaultProps = {
  showCreatedAt: false,
  data: 'null',
};

const MoreNewsCardBlockWithQuery = withQuery(MoreNewsCards);

const MoreNewsCardBlock = ({ variables, showCreatedAt, offset }) => {
  const { prefix, hasLocalNews, newsboard } = useSiteContext();
  const fetchPolicy = useNoCacheOnServerFetchPolicy();
  const field = getArticlesField(prefix, hasLocalNews);

  return (
    <MoreNewsCardBlockWithQuery
      query={getArticlesQuery(field)}
      field={field}
      showCreatedAt={showCreatedAt}
      variables={{
        offset,
        featured: false,
        limit: 4,
        sort: 'CREATED_AT',
        statuses: ['PUBLISHED'],
        categoryIds: featuredCategoryIds,
        newsboards: [newsboard],
        imageConfigurations,
        ...variables,
      }}
      errorMessage={errorMessage}
      fetchPolicy={fetchPolicy}
    />
  );
};

MoreNewsCardBlock.cardinality = 4;

MoreNewsCardBlock.propTypes = {
  variables: PropTypes.shape({}),
  showCreatedAt: PropTypes.bool,
  offset: PropTypes.number,
};

MoreNewsCardBlock.defaultProps = {
  variables: null,
  showCreatedAt: false,
  offset: 0,
};

export default MoreNewsCardBlock;
